<!-- <section> -->
<div class="loading" *ngIf="showLoading">
  <app-spinner></app-spinner>
</div>

<!-- table content -->
<div>
  <ng-content select="[table-item]"></ng-content>
</div>
<ng-container *ngIf="!showLoading && (length === 0 || !length)">
  <div class="empty-state">
    <app-empty-state></app-empty-state>
  </div>
</ng-container>
<!-- paginator -->
<ng-container *ngIf="showPaginator && length > 0">
  <div>
    <app-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="length" (paginationFilter)="getPaginationFilter($event)"></app-paginator>
  </div>
</ng-container>
<!-- </section> -->
